// pages/OrganizationConnectionsPage.tsx
import { useParams } from 'react-router-dom';
import OrganizationConnectionsTable from '../MyCCO Pro/OrganizationConnectionsTable';
import { useTranslation } from 'react-i18next';

const OrganizationConnectionsPage = () => {
  const { t } = useTranslation();
  const { contactId } = useParams();

  return (
    <div id="main-content" >
        <div className="cco_content_area cco_content_area_0">
            <article className="react-container">
               <form
                    className="cco_form">
                      <div className="cco_section cco_section_0">
                        <div className="cco_row">
                            <div className="cco_col">
        <OrganizationConnectionsTable contactId={contactId} />
        </div>
        </div>
        </div>
        </form>
      </article>
    </div>
    </div>
  );
};

export default OrganizationConnectionsPage;
